import CompoundInterestCalculator from './components/compound-interest-calculator/compound-interest-calculator';
import './App.css';

function App() {
  return (
    <CompoundInterestCalculator />
  );
}

export default App;
